import * as stylex from "@stylexjs/stylex";
import "@/design/tokens.stylex";
import { colors, motion, radii } from "@/design/tokens.stylex";
const rotate = "x1wc8ddo-B";

// Small shared recipes so every control draws the same focus ring, hairline and
// truncation. Spread them into stylex.props alongside a component's own styles.
export const recipes = {
  focusRing: {
    kI3sdo: "x1a2a7pz x7s17av",
    kInvED: "x1y3gkto",
    $$css: true
  },
  hairlineBottom: {
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xaecqrk",
    $$css: true
  },
  hairlineBottomSoft: {
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xm50ttx",
    $$css: true
  },
  hairlineTopSoft: {
    kEafiO: "x178xt8z",
    kPef9Z: "x13fuv20",
    kLZC3w: "xq9jyqv",
    $$css: true
  },
  surface: {
    kWkggS: "x1h1f4i9",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xzbo3x7",
    kaIpWk: "xhrzdqn",
    $$css: true
  },
  spinning: {
    kKVMdj: "x1aerksh",
    k44tkh: "xegkacw",
    ko0y90: "xa4qsjk",
    kyAemX: "x1esw782",
    $$css: true
  },
  truncate: {
    k7Eaqz: "xeuugli",
    kVQacm: "xb3r6kr",
    kg5iWk: "xlyipyv",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  tabular: {
    kcqcaj: "xss6m8b",
    $$css: true
  },
  srOnly: {
    kVAEAm: "x10l6tqk",
    kzqmXN: "x1i1rx1s",
    kZKoxP: "xjm9jq1",
    kmVPX3: "x1717udv",
    kogj98: "xkdpibf",
    kVQacm: "xb3r6kr",
    kMcinP: "xzpqnlu",
    khDVqt: "xuxw1ft",
    kMzoRj: "xc342km",
    $$css: true
  },
  transition: {
    kIyJzY: "x1bqwue",
    k1ekBW: "x3aw541",
    kAMwcw: "x1cgqqw5",
    $$css: true
  },
  bareButton: {
    kysU6D: "xjyslct",
    kWkggS: "xjbqb8w",
    kMzoRj: "xc342km",
    kmVPX3: "x1717udv",
    kogj98: "x1ghz6dp",
    kMwMTN: "x1heor9g",
    kMv6JI: "xjb2p0i",
    kGuDYH: "x1qlqyl8",
    k63SB2: "x1pd3egz",
    kLWn49: "x15bjb6t",
    k9WMMc: "x16tdsg8",
    kkrTdU: "x1ypdohk x1s07b3s",
    $$css: true
  },
  link: {
    kMwMTN: "xgwkh9f",
    kybGjl: "x1bvjpef",
    k1TLXF: "xadq48a x1ron9d3",
    kcSHmL: "xda060z",
    $$css: true
  }
};